import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CaretRight, UsersThree, Target, ClipboardText } from "@phosphor-icons/react";

export default function HeadCoachOverview() {
  const [players, setPlayers] = useState(null);
  const [users, setUsers] = useState(null);
  const [goals, setGoals] = useState(null);

  useEffect(() => {
    api.get("/players").then((r) => setPlayers(r.data));
    api.get("/users").then((r) => setUsers(r.data));
    api.get("/goals").then((r) => setGoals(r.data));
  }, []);

  const coaches = users?.filter((u) => u.role === "coach" || u.role === "head_coach") || [];

  return (
    <div className="space-y-5" data-testid="head-coach-overview">
      <div>
        <div className="font-label">Club overview</div>
        <h1 className="font-heading uppercase text-3xl sm:text-4xl tracking-tight">Admin</h1>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Stat label="Players" value={players?.length} icon={UsersThree} testid="stat-players" />
        <Stat label="Coaches" value={coaches.length} icon={ClipboardText} testid="stat-coaches" />
        <Stat label="Active goals" value={goals?.filter((g) => g.status === "active").length} icon={Target} testid="stat-goals" />
      </div>

      <section>
        <div className="font-label mb-2">All players</div>
        <div className="grid sm:grid-cols-2 gap-2">
          {players?.map((p) => (
            <Link
              key={p.id}
              to={`/players/${p.id}`}
              className="surface p-4 flex items-center justify-between hover:border-[#dfff00]/40 transition-colors"
              data-testid={`hc-player-${p.id}`}
            >
              <span className="font-semibold">{p.name}</span>
              <CaretRight size={18} className="text-zinc-600" />
            </Link>
          ))}
        </div>
      </section>

      <section>
        <div className="font-label mb-2">Coaches</div>
        <div className="grid sm:grid-cols-2 gap-2">
          {coaches.map((c) => (
            <div key={c.id} className="surface p-4 flex items-center justify-between" data-testid={`hc-coach-${c.id}`}>
              <div>
                <div className="font-semibold">{c.name}</div>
                <div className="text-xs text-zinc-500">{c.email}</div>
              </div>
              <span className="role-badge">{c.role.replace("_", " ")}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function Stat({ label, value, icon: Icon, testid }) {
  return (
    <div className="surface p-4" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div className="font-label">{label}</div>
        <Icon size={16} className="text-zinc-600" />
      </div>
      <div className="font-heading text-4xl text-[#dfff00] mt-1">{value ?? "—"}</div>
    </div>
  );
}
